import { ALL_PRODUCTS } from "constants";
import _ from "lodash";
import moment from "moment";
import http from "services/httpService";

import AttributeSum from "assets/svgs/attributes/attr_sum_insured.svg";
import AttributeDisease from "assets/svgs/attributes/attr_disease_wise.svg";
import AttributeMaternity from "assets/svgs/attributes/attr_maternity.svg";
import AttributeAmbulance from "assets/svgs/attributes/attr_ambulance.svg";
import AttributeOpd from "assets/svgs/attributes/attr_opd.svg";
import AttributeHealth from "assets/svgs/attributes/attr_health_checkup.svg";
import AttributeRoom from "assets/svgs/attributes/attr_room.svg";
import AttributeCopay from "assets/svgs/attributes/attr_copay.svg";

import ProductGmc from "assets/svgs/products/gmc.svg";
import ProductGpa from "assets/svgs/products/gpa.svg";
import ProductGtl from "assets/svgs/products/gtl.svg";
import ProductParental from "assets/svgs/products/parental.svg";
import ProductTop from "assets/svgs/products/top_up.svg";
import ProductOpd from "assets/svgs/products/opd.svg";
import HealthCheckup from "assets/svgs/products/health_checkup.svg";
import tooth from "assets/svgs/products/tooth.svg";
import ProductGmcBg from "assets/svgs/products/backgrounds/gmc.svg";
import ProductGpaBg from "assets/svgs/products/backgrounds/gpa.svg";
import ProductGtlBg from "assets/svgs/products/backgrounds/gtl.svg";
import ProductTopUpBg from "assets/svgs/products/backgrounds/topup.svg";
import ProductHealthCheckup from "assets/svgs/products/backgrounds/hc.svg";
import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";
import StarSvg from "assets/svgs2026/starIconSvg.svg"


export function validateAlphaOnly(value) {
  let error = "";
  if (!value) {
    error = "*Required";
  } else if (!/^([A-Za-z]?[\s]*)+$/.test(value)) {
    error = "*enter alphabets only.";
  }
  return error;
}

export function findInValues(arr, value) {
  const searchVal = String(value).toLowerCase();
  return arr.filter((o) =>
    Object.entries(o).some((entry) =>
      String(entry[1]).toLowerCase().includes(searchVal),
    ),
  );
}

export function validatePhone(value) {
  let error;
  if (!value) {
    error = "*Required";
  } else if (!/^\d{10}$/.test(value)) {
    error = "*enter 10 digit Phone Number.";
  }
  return error;
}

export function toTitleCase(str) {
  return (
    str &&
    str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    })
  );
}

export function formatDateSequence(date) {
  let new_date;
  new_date = date.split("-").reverse().join("/");
  return new_date;
}
export function formatDate(date) {
  if (!date) return;
  let new_date;
  new_date = date.split("/").reverse().join("-");
  return new_date;
}

export function getAllUrlParams(url, ignoreCaseSensitivity) {
  var queryString = url
    ? url.split("?")[1] || url.split("#")[1]
    : window.location.search.slice(1);
  var obj = {};
  if (queryString) {
    queryString = queryString.split("#")[0];
    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split("=");
      var paramName = a[0];
      var paramValue = typeof a[1] === "undefined" ? true : a[1];
      paramName = ignoreCaseSensitivity ? paramName : paramName.toLowerCase();

      if (typeof paramValue === "string")
        paramValue = ignoreCaseSensitivity
          ? paramValue
          : paramValue.toLowerCase();
      if (paramName.match(/\[(\d+)?\]$/)) {
        var key = paramName.replace(/\[(\d+)?\]/, "");
        if (!obj[key]) obj[key] = [];
        if (paramName.match(/\[\d+\]$/)) {
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          obj[key].push(paramValue);
        }
      } else {
        if (!obj[paramName]) {
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === "string") {
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

export function setUtmData(utm_source, utm_campaign, utm_medium, referralCode) {
  if (utm_source) localStorage.setItem("utm_source", utm_source);
  if (utm_medium) localStorage.setItem("utm_medium", utm_medium);
  if (utm_campaign) localStorage.setItem("utm_campaign", utm_campaign);
  if (referralCode) {
    referralCode = referralCode.toUpperCase();
    localStorage.setItem("referralCode", referralCode);
  }
}

export function getCompanyName() {
  return localStorage.getItem("company_name");
}

export const appendScript = () => {
  let scriptToAppend = `
      (function(d,h,e,v,n) {
      if(d.dht)
      return;
      n=d.dht=function() {
      n.track?n.track.apply(n,arguments):n.queue.push(arguments)
    }
      n.queue=[];
      t=h.createElement(e);
      t.async=!0;
      t.src=v;
      t.id="dht";
      s=h.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    }(window, document, 'script', 'https://assets-money.dailyhunt.in/dht.min.js'));
      dht('init', '')`;

  const script = document.createElement("script");
  script.innerHTML = scriptToAppend;
  script.async = true;
  document.body.appendChild(script);
};

export function validateDOB(value) {
  let error;
  if (!value) {
    error = "*Required.";
  } else if (value.length < 10) {
    error = "Date must be in DD/MM/YYYY format";
  } else if (value.length === 10) {
    const age = moment().diff(
      moment(value.split("/").reverse().join(), "YYYYMMDD"),
      "years",
    );
    let daysInDiff = moment().diff(
      moment(value.split("/").reverse().join(), "YYYYMMDD"),
      "days",
    );
    if (daysInDiff <= 0 || isNaN(age) || age < 0 || age > 120)
      error = "DOB is invalid";
  }
  return error;
}

export function formatAmountWithDecimal(amountWithdecimal) {
  if (
    !amountWithdecimal ||
    amountWithdecimal === "" ||
    amountWithdecimal === "-"
  )
    return amountWithdecimal;

  // Convert to number if it's a string
  const numValue =
    typeof amountWithdecimal === "string"
      ? parseFloat(amountWithdecimal.replace(/,/g, ""))
      : amountWithdecimal;

  if (isNaN(numValue)) return amountWithdecimal;

  // Use Indian number formatting
  return formatIndianNumber(numValue);
}

export function formatAmount(amount) {
  if (!amount) return 0;

  // Handle comma-separated values by removing commas before converting to number
  if (typeof amount === "string") {
    amount = amount.replace(/,/g, "");
  }

  if (String(amount).length <= 3) return amount;

  let a = amount.toString();
  amount = Number(amount);
  let l = a.length;
  let res = "," + a.substr(l - 3, l);
  amount = Math.floor(amount / 1000);
  while (amount.toString().length > 2) {
    a = amount.toString();
    l = a.length;
    res = "," + a.substr(l - 2, l) + res;
    amount = Math.floor(amount / 100);
  }
  a = amount.toString();
  return a + res;
}

export function formatDateReverse(date) {
  if (!date) return null;
  let new_date;
  new_date = date.split("-").reverse().join("/");
  return new_date;
}

export function formatDateYYYY(date) {
  let dateDay =
    date && date.slice(0, date.indexOf("T")).split("-").reverse().join("/");
  return dateDay;
}

export function formatBackEndDateDDMMYY(date) {
  let originalDate = date;
  try {
    if (!date) return "-";
    let datePart =
      date.indexOf("T") !== -1
        ? date.slice(0, date.indexOf("T"))
        : date.split(" ")[0];
    let dateDay = datePart.split("-").reverse();
    if (dateDay.length === 3) {
      dateDay[2] = dateDay[2].slice(2);
      return dateDay.join("/");
    }
    return dateDay.join("/");
  } catch (ex) {
    console.error({ date: originalDate });
    return "-";
  }
}

export const addLeadingZero = (value) => {
  if (value) {
    return value < 10 ? `0${value}` : value.toString();
  }
};

// convert text into the format of "Hello World"
export function capitalizeWords(text) {
  let words = text.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] =
      words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
  }
  return words.join(" ");
}
// upload files
export async function uploadFile(file, type) {
  let fileId = null;
  // returning if no file
  if (!file) return;

  // initializing adn setting up formData
  const formData = new FormData();
  formData.append("file_details", file);
  formData.append("file_owner", localStorage.getItem("id"));
  formData.append("file_type", type);
  // setting request option to form-data
  const options = {
    "Content-Type": "multipart/form-data",
  };

  try {
    const { data } = await http.post(
      "/insurance/upload_document/",
      formData,
      options,
    );
    // updating fileId if id is present in response
    if (data?.id) {
      fileId = data.id;
      const isCoverageDocScreen =
        type === "benifit_manual" || type === "policy_schedule";
      const userplanId = localStorage.getItem("eb_current_plan");
      if (isCoverageDocScreen && userplanId) {
        await http.post("/insurance/upload_coverage_documents/", {
          userplan_id: userplanId,
          id: data.id,
        });
      }
    }
  } catch (err) {
    console.warn(err);
  }

  return fileId;
}

export const products = () => {
  const planType = Object.keys(JSON.parse(localStorage.getItem("products")));
  planType.sort();
  var options = [];
  planType.forEach((type) => {
    options.push({ value: type, label: ALL_PRODUCTS[type] });
    // switch (type) {
    //   case 'GMC':
    //   case 'GMC_M':
    //     options.push({value: type, label: 'Group Health Insurance'});
    //     break;
    //   case 'GTL':
    //     options.push({value: type, label: 'Group Term Life'});
    //     break;
    //   case 'GPA':
    //     options.push({value: type, label: 'Group Personal Accident'});
    //     break;
    //   default:
    //     break;
    // }
  });
  return options;
};

export const userplanIdFlex = (selectedValue) => {
  const products = JSON.parse(localStorage.getItem("products"));
  return products[selectedValue]["userplan"];
};

export const logoutHandler = (navigate) => {
  localStorage.clear();
  sessionStorage.clear();
  window.history.go(-window.history.length);
  navigate("/");
};

export function formatToPascalCase(str) {
  return str
    .split("_")
    .map((word) => _.startCase(word))
    .join(" ");
}

export const ivnvokePlanSetup = (bool_value) => {
  localStorage.setItem("plan_setup_from_scratch", bool_value);
  localStorage.removeItem("plan_setup_pending");
};

export const exitPlanSetupOrPending = () => {
  localStorage.removeItem("plan_setup_from_scratch");
  localStorage.removeItem("plan_setup_pending");
};

export const invokePendingPlanSetup = (bool_value) => {
  localStorage.setItem("role", "admin");
  localStorage.setItem("plan_setup_pending", bool_value);
  localStorage.removeItem("plan_setup_from_scratch");
};

export const planSetupPendingInProgress = () => {
  const planSetupPending = JSON.parse(
    localStorage.getItem("plan_setup_pending"),
  );
  if (planSetupPending) {
    return true;
  }
  return false;
};

export const planSetupInProgress = () => {
  const planSetupInProgress = JSON.parse(
    localStorage.getItem("plan_setup_from_scratch"),
  );
  if (!planSetupInProgress) {
    return false;
  }
  return true;
};

export const roleIsAdmin = () => {
  let isAdmin = localStorage.getItem("role");
  if (isAdmin === "admin") {
    return true;
  }
  return false;
};

export const formatNumberToIndian = (x) => {
  x = x.toString();
  let afterPoint = "";
  if (x.indexOf(".") > 0) {
    afterPoint = x.substring(x.indexOf("."), x.length);
  }
  x = Math.floor(x);
  x = x.toString();
  let lastThree = x.substring(x.length - 3);
  let otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers != "") {
    lastThree = "," + lastThree;
  }
  return (
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint
  );
};

// export function newFormatRupees(input) {
//   if (!input || input === "" || input === "-") return input;

//   // Convert input to a number if it's a string
//   const number = typeof input === "string" ? parseFloat(input.replace(/,/g, '')) : input;

//   // Check if the input is a valid number
//   if (isNaN(number)) {
//     return input;
//   }

//   // Use Indian number formatting
//   const formatted = formatIndianNumber(number);
//   return `₹${formatted}`;
// }

export function newFormatRupees(input) {
  if (!input || input === "" || input === "-") return input;

  // Convert input to a number if it's a string
  const number =
    typeof input === "string" ? parseFloat(input.replace(/,/g, "")) : input;

  // Check if the input is a valid number
  if (isNaN(number)) {
    return input;
  }

  const cleanedInput =
    typeof input === "string" ? input.replace(/,/g, "") : input;

  // Handle Nx of CTC format
    if (typeof cleanedInput === "string") {
      const ctcMatch = cleanedInput.match(/^(\d+)\s*x\s*of\s*ctc$/i);

      if (ctcMatch) {
        return `${ctcMatch[1]}x of CTC`;
      }
    }
    // If the entire value is not a valid number, return it unchanged
    if (isNaN(cleanedInput)) {
      return input;
    }

  const formatted = formatNumberToIndian(Number(cleanedInput));
  return `₹${formatted}`;
}

export function newFormatRupeesWithDecimals(input) {
  if (input === null || input === undefined || input === "" || input === "-") return input;

  const number =
    typeof input === "string" ? parseFloat(input.replace(/,/g, "")) : input;

  if (isNaN(number)) {
    return input;
  }

  // Always enforces exactly 2 decimal places
  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return `₹${formatted}`;
}

export function formatDecimalToCSV(number) {
  if (!number || number === "" || number === null || number === undefined)
    return "0";

  // Handle comma-separated values by removing commas before converting to number
  if (typeof number === "string") {
    number = number.replace(/,/g, "");
  }

  number = Number(number);
  if (isNaN(number)) return "0";
  return number.toLocaleString("en-IN");
}

export const formatToRs = (value, showSymbol = true) => {
  if (!value || value === "" || value === "-") return value;

  // Convert to number if it's a string
  const numValue =
    typeof value === "string"
      ? parseFloat(value.replace(/[^\d.-]/g, ""))
      : value;

  if (isNaN(numValue)) return value;

  // Use Indian number formatting
  const formatted = formatIndianNumber(numValue);

  if (showSymbol) {
    return "Rs." + formatted;
  } else {
    return formatted;
  }
};
export const formatCtcValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    const ctcMatch = value.match(/^(\d+)\s*x\s*of\s*ctc$/i);

    if (ctcMatch) {
      return `${ctcMatch[1]}x of CTC`;
    }

    if (!isNaN(value.replace(/,/g, ""))) {
      return value;
    }
  }

  return value;
};
export const formatToRupees = (value, showSymbol = true) => {
  function differentiate(value) {
    if (typeof value === "string" && !isNaN(Number(value))) {
      return "number";
    } else if (typeof value === "number") {
      return "number";
    } else if (typeof value === "string") {
      return "string";
    } else {
      return "other";
    }
  }

  if (differentiate(value) !== "number") return value;

  const enteredValue = value;
  if (!enteredValue) return;
  if (enteredValue.replace) {
    const cleanedValue = enteredValue.replace(/[^\d.-]/g, "");
    if (!cleanedValue) return "";
    const parsedValue = parseFloat(cleanedValue);
    if (!isNaN(parsedValue)) {
      if (showSymbol) {
        // Format with the Rupee symbol
        return parsedValue.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true,
        });
      } else {
        // Format without the Rupee symbol, just as a number
        return parsedValue.toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true,
        });
      }
    } else {
      return enteredValue;
    }
  }
  return value;
};

export const rupeesToNumber = (value) => {
  if (!value) return 0;
  if (typeof value == "number") return value;
  // var cleanedValue = value?.replace(/[^\d.-]/g, "");
  // cleanedValue = Number(cleanedValue);
  // return cleanedValue;

  //previous code was removing any non numeric to "".
  //Here we return string as it is. 
    if (/[a-zA-Z]/.test(value)) {
    return value;
  }

  return Number(value.replace(/[^\d.-]/g, ""));
};

export const validateMobileNumber = (number) => {
  if (!/^\d{10}$/.test(number)) {
    return false;
  }

  return true;
};

export const validateMobileNumberFor20Digit = (number) => {
  if (!/^\d{20}$/.test(number)) {
    return false;
  }

  return true;
};

export const isFlexFlow = () => {
  const flow = localStorage.getItem("flow");
  return flow === "FLEX";
};

export const isGmcFlow = () => {
  const flow = localStorage.getItem("flow");
  return flow === "GMC" || flow === "GMC_M";
};
export const updateFlexUserPlanIds = (product, userPlanId) => {
  const flexUserplanIds = localStorage.getItem("flex_userplan_ids");
  const parsedFlexUserplanIds = flexUserplanIds
    ? JSON.parse(flexUserplanIds)
    : {};
  const newFlexUserplanIds = {
    ...parsedFlexUserplanIds,
    [product]: userPlanId,
  };
  localStorage.setItem("flex_userplan_ids", JSON.stringify(newFlexUserplanIds));
};

export const getFileNameFromUrl = (url) => {
  if (!url) return "";
  const index = url.lastIndexOf("/");
  const fileName = url.substring(index + 1);
  return fileName;
};

//product name to display name
export const DisplayName = (value) => {
  let name =
    value &&
    value.replace(/_/g, " ").replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
  return name;
};

export const healthIssuancePresent = (value) => {
  const details = JSON.parse(localStorage.getItem("gmc_details")) || value;
  if (!details) return false;
  let boolean_value = Object.keys(details).includes("health_insurance");
  if (boolean_value) {
    boolean_value = details["health_insurance"]?.userplan_id;
  }
  return boolean_value;
};
export const opdPresent = (value) => {
  const details = value;
  if (!details) return false;
  let boolean_value = Object.keys(details).includes("opd_cover");
  if (boolean_value) {
    boolean_value = details["opd_cover"]?.userplan_id;
  }
  return boolean_value;
};

export const showCorporateBuffer = (value) => {
  const details = value || JSON.parse(localStorage.getItem("gmc_details"));
  if (!details) return false;
  let boolean_value = Object.keys(details).includes("health_insurance");
  if (boolean_value) {
    boolean_value = details["health_insurance"]?.is_corporatebuffer;
  }
  return boolean_value;
};

export function capitalizeSecondLetter(text) {
  if (!text) return "";

  return text
    .replace(/_/g, " ")
    .split(/\s+/)
    .map((word, index) => {
      if (index === 0) {
        if (word.toLowerCase() === "critical") {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }

        return word.toUpperCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export const removeCommas = (value) => {
  // Check if value is null or undefined
  if (value == null) {
    return null;
  }

  // Ensure the value is a string to prevent errors
  const stringValue = String(value);

  // Remove commas and return
  return stringValue.replace(/,/g, "");
};

export const removeCommasAndConvertToNumber = (value) => {
  // Check if value is null or undefined
  if (value == null || value === "") {
    return null;
  }

  // Ensure the value is a string to prevent errors
  const stringValue = String(value);

  // Remove commas and convert to number
  const numberValue = parseFloat(stringValue.replace(/,/g, ""));

  // Return null if conversion failed
  return isNaN(numberValue) ? null : numberValue;
};

export const formatToIndianSystem = (value) => {
  if (!value) return "";

  value = value.toString();

  // Remove existing commas first
  const cleanValue = value.replace(/,/g, "");
  
  // If it's not a pure number, return it unchanged
  if (!/^\d+(\.\d+)?$/.test(cleanValue)) {
    return value;
  }

  let [integer, fraction] = cleanValue.split(".");
  let lastThree = integer.substring(integer.length - 3);
  let otherNumbers = integer.substring(0, integer.length - 3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }
  const output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  return fraction ? `${output}.${fraction}` : output;
};

export const dependentsFormation = (descriptionData) => {
  let result = "";
  let companiesWithNoGrades = ["Dover India Private Limited"];
  let currentComp = localStorage.getItem("company_name");
  let toShowAndOr = companiesWithNoGrades.includes(currentComp)
    ? " or "
    : " and ";

  const replaceInLaws = (array) => {
    return array.map((relationship) => {
      if (relationship === "In-Laws") {
        return "In-laws";
      } else {
        return relationship;
      }
    });
  };
  descriptionData = replaceInLaws(descriptionData);
  if (descriptionData.length === 1) {
    result = descriptionData[0];
  } else if (descriptionData.length === 2) {
    result = descriptionData.join(toShowAndOr);
  } else {
    result =
      descriptionData.slice(0, -1).join(", ") +
      toShowAndOr +
      descriptionData.slice(-1);
  }
  return result;
};

export const ChartAttributeName = (value) => {
  return _.capitalize(value);
  if (!value) return;
  const word = value.split("_")[0];
  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "";
};

export const formatRelationship = (value) => {
  if (value === "SELF") return "Employees";
  if (value.toLowerCase() == "motherinlaw") return "Mother-in-Law";
  if (value.toLowerCase() == "fatherinlaw") return "Father-in-Law";
  return _.capitalize(value);
};

export const getAttributeIcon = (attributeName) => {
  let img = AttributeSum;
  switch (attributeName) {
    case "Sum Insured":
      img = AttributeSum;
      break;
    case "Maternity Coverage":
      img = AttributeMaternity;
      break;
    case "Co Payment":
      img = AttributeCopay;
      break;
    case "Ambulance Charges":
      img = AttributeAmbulance;
      break;
    case "Room Rent Per Day Limit":
      img = AttributeRoom;
      break;
    case "OPD Coverage":
      img = AttributeOpd;
      break;
    case "Health Checkup Coverage":
      img = AttributeHealth;
      break;
    case "Disease Wise Sub limit":
      img = AttributeDisease;
  }
  return img;
};

export const getProductIcon = (product) => {
  let img = ProductGmc;
  switch (product) {
    case "health_insurance":
      img = ProductGmc;
      break;
    case "health_insurance_additional":
      img = ProductGmc;
      break;
    case "personal_accident":
      img = ProductGpa;
      break;
    case "term_life":
      img = ProductGtl;
      break;
    case "opd_cover":
      img = ProductOpd;
      break;
    case "top_up_health":
      img = ProductTop;
      break;
    case "parental_cover":
      img = ProductParental;
      break;
    case "health_insurance_parents":
      img = ProductParental;
      break;
    case "health_insurance_parents_in_laws":
      img = ProductParental;
      break;
    case "HEALTH_CHECKUP":
      img = HealthCheckup;
      break;
    case "DENTAL":
      img = tooth;
      break;
  }
  return img;
};

export const parentalProducts = [
  "parental_cover",
  "health_insurance_parents",
  "health_insurance_parents_in_laws",
];

export const getProductDescription = (product, productKey) => {
  switch (productKey) {
    case "health_insurance":
    case "health_insurance_additional":
      return `Medical cover for ${dependentsFormation(
        product.dependents_allowed_union,
      )}`;
    case "personal_accident":
      return "Coverage for accidental death or permanent disablement";
    case "term_life":
      return "For financial protection against loss of life";
    case "opd_cover":
      return `Out patient cover for ${dependentsFormation(
        product.dependents_allowed_union,
      )}`;
    case "top_up_health":
      return "Total amount of medical expenses which will be covered as per the policy terms after the base cover is exhausted";
    case "parental_cover":
      return "Medical cover for Parents and In-laws";
    case "health_insurance_parents":
      return "Medical cover for Parents";
    case "health_insurance_parents_in_laws":
      return "Medical cover for In-laws";
    case "critical_illness":
      return "For financial protection against loss of life";
    case "HEALTH_CHECKUP":
      return "Full body health checkup for overall health care with 83 tests";
    case "DOCTOR_CONSULTATION":
      return "With general physicians and specialists from top hospitals";
  }
};

export const getProductBgAbstractionImg = (product) => {
  switch (product) {
    case "health_insurance":
    case "health_insurance_additional":
      return ProductGmcBg;
    case "personal_accident":
      return ProductGpaBg;
    case "term_life":
      return ProductGtlBg;
    case "parental_cover":
      return ProductTopUpBg;
    case "health_insurance_parents":
      return ProductTopUpBg;
    case "health_insurance_parents_in_laws":
      return ProductTopUpBg;
    case "top_up_health":
      return ProductTopUpBg;
  }
};

export const joinWithAndLine = (arr) => {
  if (arr.length === 0) {
    return "";
  } else if (arr.length === 1) {
    return arr[0];
  } else if (arr.length === 2) {
    return arr.join(" and ");
  } else {
    return arr.slice(0, -1).join(" | ") + " | " + arr[arr.length - 1];
  }
};

export const joinWithAndComma = (arr) => {
  let companiesWithNoGrades = ["Dover India Private Limited"];
  let currentComp = localStorage.getItem("company_name");
  let toShowAndOr = companiesWithNoGrades.includes(currentComp)
    ? " or "
    : " and ";

  if (arr.length === 0) {
    return "";
  } else if (arr.length === 1) {
    return arr[0];
  } else if (arr.length === 2) {
    return arr.join(toShowAndOr);
  } else {
    return arr.slice(0, -1).join(", ") + toShowAndOr + arr[arr.length - 1];
  }
};

export const getProductFromUserplan = (userplan) => {
  const products = JSON.parse(localStorage.getItem("products"));
  if (!products) return null;

  const productKey = Object.keys(products).find(
    (key) => products[key].userplan === userplan,
  );
  return { ...products[productKey], name: productKey };
};

// Number formatting function with commas
export const formatIndianNumber = (value) => {
  if (!value || value === "" || value === "-") return value;

   // If it's a string, ensure it's purely numeric
  if (
    typeof value === "string" &&
    !/^\d+(\.\d+)?$/.test(value.replace(/,/g, ""))
  ) {
    return value;
  }

  // Convert to number if it's a string
  const numValue = typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;

  if (isNaN(numValue)) return value;

  // Use simple comma formatting
  return numValue.toLocaleString("en-IN");
};

// Format value with Rs prefix and Indian comma formatting if it's a pure number
// Otherwise, return the value as-is
export const formatPlanOverviewValue = (value) => {
  if (!value || value === "" || value === "-") return value;

  // Convert to string if it's not already
  const stringValue = String(value).trim();

  // If the value ends with %, it's a percentage - return as-is
  if (stringValue.endsWith("%")) {
    return value;
  }

  // Check if the string contains only numbers (optional minus sign, digits, and optional decimal point)
  // This regex matches: optional minus, digits, optional decimal point with digits
  const isPureNumber = /^-?\d+(\.\d+)?$/.test(stringValue);

  if (isPureNumber) {
    // Parse and format with Indian number system and add Rs prefix
    const numValue = parseFloat(stringValue);
    const formatted = numValue.toLocaleString("en-IN");
    return `₹ ${formatted}`;
  }

  // Return as-is if it's not a pure number
  return value;
};

export const userHasViewPermission = () => {
  // let userInfo = JSON.parse(localStorage.getItem("user"))
  // return userInfo?.permission === "VIEW" ? true : false
  let userInfo = JSON.parse(localStorage.getItem("login_profile"));
  return userInfo?.is_multiple_company_mapped;
};

export const isPathStrictlyV1 = () => {
  let fullUrl = window.location.pathname;
  const regex = /^\/v1\/?$/;
  return regex.test(fullUrl);
};
export const isEmptyObject = (obj) => {
  return Object.values(obj).every(
    (value) =>
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" &&
        value !== null &&
        Object.keys(value).length === 0),
  );
};

export const disableFormBtnHandler = (errors, values) => {
  let initialValuesEmpty = isEmptyObject(values);
  if (initialValuesEmpty && Object.keys(errors).length === 0) {
    return true;
  } else if (Object.keys(errors).length > 0) {
    return true;
  } else {
    return false;
  }
};

export const customPlanNameHandler = (display_name) => {
  let userData = JSON.parse(localStorage.getItem("user"));

  if (userData) {
    if (
      userData.company.company_name ===
        "No broker Technologies Solutions Private Limited" &&
      display_name === "Doctor Consultation"
    ) {
      return "Wellness Benefits";
    }
    return display_name;
  }
};

export const planDisplayNameHandler = (labelValue) => {
  const flexProdItems = FLEX_PRODUCTS.filter(
    (each_prod) => each_prod.value === labelValue,
  );

  if (flexProdItems.length > 0) {
    return flexProdItems[0].display_name;
  } else {
    return labelValue;
  }
};

export function formatDateToDDMMYYYY(dateInput) {
  if (!dateInput) return "--";

  const date = new Date(dateInput);

  // Return original input or fallback if the date string is invalid
  if (isNaN(date.getTime())) return dateInput;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export const isValidNumeric = (numValue) => {
  if (numValue === null || numValue === undefined) return false;
  
  // Convert string input (e.g., "4000") or keep numeric input
  const parsed = parseInt(numValue, 10);
  
  // Ensure it parsed to a valid integer and handles empty/whitespace strings
  return !Number.isNaN(parsed) && String(numValue).trim() !== "";
};

export const valueEmptyNonEmptyHandler = (valueInput) => {
  if(isValidNumeric(valueInput)) {
    return formatToRupees(valueInput)
  } else if (!isValidNumeric(valueInput) && valueInput !== null) {
    return valueInput
  } else {
    return "-"
  }
}

export const starLineWrapperJsx = (content, iconHeight="", iconWidth="" ) => {
  return (
    <div style={{ display: "flex", gap: "8px"}}>
      <div className="avoid-word-break">
        {content}
      </div>
      <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
        <img height={iconHeight} width={iconWidth} src={StarSvg} alt="StarSvg" />
        <div className="starLineCss" style={{ width: "100%" }} />
      </div>
    </div>
  )
}

export const starLineWrapperJsxWordBreak = (content, iconHeight="", iconWidth="") => {
  return (
    <div style={{ display: "flex", gap: "8px"}}>
      <div>
        {content}
      </div>
      <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
        <img height={iconHeight} width={iconWidth} src={StarSvg} alt="StarSvg" />
        <div className="starLineCss" style={{ width: "100%" }} />
      </div>
    </div>
  )
}

export const starLineWrapperJsxW100 = (content) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <div>
          <span className="premium-calc-css">
            {content}
          </span>
        </div>
        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
          <img src={StarSvg} alt="StarSvg" />
          <div className="starLineCss" style={{ width: "100%" }} />
        </div>
      </div>

    </div>
  )
}

export const getShortMonths = (monthsList) => {
  let updatedMonths = []
  monthsList.map((each_month) => updatedMonths.push(each_month.slice(0, 3)))
  return updatedMonths
};

export const isValidDate = (value) => {
  // 1. Direct Date object check
  if (Object.prototype.toString.call(value) === '[object Date]') {
    return !isNaN(value.getTime());
  }

  // 2. Reject non-string / non-number inputs (arrays, objects, booleans, null, undefined)
  if (typeof value !== 'string' && typeof value !== 'number') {
    return false;
  }

  // 3. String & Number validation
  const strValue = String(value).trim();
  
  // Reject empty strings or plain numeric strings like "123" or "2024" (parsed as years by Date)
  if (!strValue || /^\d+$/.test(strValue)) {
    return false;
  }

  const parsed = new Date(strValue);
  return !isNaN(parsed.getTime());
}

export const flattenArray = (arrayOfArrays) => {

  const needsFlattening = arrayOfArrays.some((item) => Array.isArray(item))

  if(!needsFlattening) {
    return arrayOfArrays
  }

  return arrayOfArrays.flat()
}